import { Provider } from '@angular/core';

import { provideFormWizardFieldAdapter } from '@shared/components/form/form-wizard/form-wizard-field-registry.service';

import { InvestmentBuildingsFormFieldComponent } from './investment-buildings-form-field.component';
import { InvestmentAmenitiesSelectorFormFieldComponent } from './investment-amenities-selector-form-field.component';
import { InvestmentDescriptionFormFieldComponent } from './investment-description-form-field.component';

export const INVESTMENT_FORM_WIZARD_PROVIDERS: Provider[] = [
  provideFormWizardFieldAdapter(
    'buildingsEditor',
    InvestmentBuildingsFormFieldComponent
  ),
  provideFormWizardFieldAdapter(
    'descriptionEnhanced',
    InvestmentDescriptionFormFieldComponent
  ),
  provideFormWizardFieldAdapter(
    'amenitiesSelector',
    InvestmentAmenitiesSelectorFormFieldComponent
  ),
];
